import { v4 } from 'uuid'

export function uuidToStableIntegerId(uuid = v4(), maxInteger = 4) {
  uuid = uuid.replace(/-/g, '').toLowerCase()

  const highBits = parseInt(uuid.substr(0, 8), 16)
  const lowBits = parseInt(uuid.substr(24, 8), 16)

  const stableId = ((highBits + lowBits) % maxInteger) + 1

  return stableId
}

export function seededRandom(seed: number): () => number {
  let value = seed % 2147483647
  if (value <= 0) value += 2147483646

  return function () {
    value = (value * 16807) % 2147483647
    return (value - 1) / 2147483646
  }
}

export function shuffleArray<T>(array: T[], seed: number): T[] {
  const random = seededRandom(seed)

  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1))
    ;[array[i], array[j]] = [array[j], array[i]]
  }

  return array
}
